import { render, staticRenderFns } from "./troca-senha.vue?vue&type=template&id=6cf3ad29&scoped=true&"
import script from "./troca-senha.vue?vue&type=script&lang=js&"
export * from "./troca-senha.vue?vue&type=script&lang=js&"
import style0 from "./troca-senha.vue?vue&type=style&index=0&id=6cf3ad29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf3ad29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
